export default "__VITE_IMAGE_ASSET__0075ace8__";